import { useInfiniteQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { ordersQueries } from '../api/ordersQueries'
import { toOrdersListParams } from '../lib/ordersListParams'
import { modifyLocalStorageOrders } from '../Orders.config'
import type { OrdersFilters } from '../types/orders.types'

export const useOrdersList = (filters: OrdersFilters, userId: string) => {
  const ordersQuery = useInfiniteQuery(
    ordersQueries.list(toOrdersListParams(filters))
  )
  const pages = ordersQuery.data?.pages

  useEffect(() => {
    pages?.forEach((page) => modifyLocalStorageOrders(page.content, userId))
  }, [pages, userId])

  return {
    ordersQuery,
    orders: pages?.flatMap((page) => page.content) ?? [],
    totalElements: pages?.[0]?.totalElements ?? null,
  }
}
